import type { Draft } from '../data/types';
import { SECTIONS } from '../data/sections';

export function draftToMarkdown(draft: Draft): string {
  const lines: string[] = [];
  lines.push(`# ${draft.title || 'a negotiation letter'}`);
  if (draft.recipient?.trim()) {
    lines.push('');
    lines.push(`*for ${draft.recipient.trim()}*`);
  }
  lines.push('');
  for (const sec of SECTIONS) {
    const body = draft.sections[sec.key]?.trim();
    if (!body) continue;
    lines.push(`## ${sec.heading}`);
    lines.push('');
    lines.push(body);
    lines.push('');
  }
  lines.push('---');
  lines.push(`*composed on ${new Date(draft.updatedAt).toLocaleDateString()}*`);
  return lines.join('\n');
}

export function draftToText(draft: Draft): string {
  const lines: string[] = [];
  lines.push((draft.title || 'a negotiation letter').toUpperCase());
  if (draft.recipient?.trim()) {
    lines.push('');
    lines.push(`for ${draft.recipient.trim()}`);
  }
  lines.push('');
  for (const sec of SECTIONS) {
    const body = draft.sections[sec.key]?.trim();
    if (!body) continue;
    lines.push(sec.heading.toUpperCase());
    lines.push('');
    lines.push(body);
    lines.push('');
    lines.push('');
  }
  lines.push(`composed on ${new Date(draft.updatedAt).toLocaleDateString()}`);
  return lines.join('\n');
}

export function downloadFile(filename: string, content: string, mime: string) {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }
  return false;
}

export function safeFilename(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'letter';
}
